import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../actions';
import UserMobilMenu from '../components/shared/header/user-mobile-menu';

import APP_ROUTES from '../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
    access_token: state.auth.access_token,
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => {
        dispatch(Actions.logout());
        dispatch(push(APP_ROUTES.homePageRoute));
    },
    isWalletActive: async (token, wallet) => {
        const active = await dispatch(Actions.activeWallet(wallet, token, true));
        return active;
    },
    activateWallet: async (token, wallet) => {
        const activate = await dispatch(Actions.activateWallet(wallet, token));
        return activate;
    },
});

const UserMobilMenuConnector = connect(mapStateToProps, mapDispatchToProps)(UserMobilMenu);

export default UserMobilMenuConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/user-mobil-menu-connector.js
 **/